import { useQuery, useMutation } from '@apollo/client';

import {
  CreateLockdownBrowserAllowlistItem,
  DeleteLockdownBrowserAllowlistItem,
  GetLockdownBrowserAllowlist
} from '@resources/lockdown-browser-allowlist.graphql';

const useLoadLockdownBrowserAllowlist = () => {
  const {
    data: { lockdownBrowserAllowlist = [] } = {},
    loading,
    error
  } = useQuery(GetLockdownBrowserAllowlist);
  return { lockdownBrowserAllowlist, loading, error };
};

const useDeleteLockdownBrowserAllowlistItem = id => {
  const [deleteName, { loading }] = useMutation(DeleteLockdownBrowserAllowlistItem, {
    variables: { id },
    update: cache => {
      const { lockdownBrowserAllowlist } = cache.readQuery({
        query: GetLockdownBrowserAllowlist
      });

      const updatedAllowlist = lockdownBrowserAllowlist.filter(item => item.id !== id);

      cache.writeQuery({
        query: GetLockdownBrowserAllowlist,
        data: {
          lockdownBrowserAllowlist: [...updatedAllowlist]
        }
      });
    }
  });

  return { deleteName, loading };
};

const useCreateLockdownBrowserAllowlistItem = programName => {
  const [onCreateNewLockdownBrowserAllowlistItem, { loading }] = useMutation(
    CreateLockdownBrowserAllowlistItem,
    {
      variables: {
        input: {
          data: programName
        }
      },
      update: (cache, { data: { lockdownBrowserAllowlistItem } }) => {
        const { lockdownBrowserAllowlist } = cache.readQuery({
          query: GetLockdownBrowserAllowlist
        });

        cache.writeQuery({
          query: GetLockdownBrowserAllowlist,
          data: {
            lockdownBrowserAllowlist: [
              ...lockdownBrowserAllowlist,
              lockdownBrowserAllowlistItem
            ]
          }
        });
      }
    }
  );

  return {
    onCreateNewLockdownBrowserAllowlistItem,
    loading
  };
};

export {
  useLoadLockdownBrowserAllowlist,
  useDeleteLockdownBrowserAllowlistItem,
  useCreateLockdownBrowserAllowlistItem
};
